import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[param]'
})
export class ParamDirective {

    constructor(public viewContainerRef: ViewContainerRef) {
    }

}
